module.exports = __webpack_public_path__ + "img/429-391cca.png";